module.exports = __webpack_public_path__ + "img/md6.15e52252.png";